module.exports = __webpack_public_path__ + "static/img/texture.6145399.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/texture.png
// module id = Om6v
// module chunks = 0